import { typeValidator } from '@chilipiper/utils'
import { Children } from 'react'
import { CascadeSelectItem, SelectSection } from '../select/PublicComponents'
import {
  DynamicCascadeItem,
  DynamicSimpleItem,
  selectItemPublicToDynamicItem,
} from './dynamicItemUtils'
import { CascadeSelectItemPublicComponent } from './publicComponentTypes'

export const createCascadePath = (
  valuesPath: readonly string[],
  root: DynamicCascadeItem,
  getLazyLoadedCollection: (
    path: string
  ) => readonly (DynamicCascadeItem | DynamicSimpleItem)[] | undefined
): DynamicCascadeItem[] => {
  let children = Children.toArray(root.children)
  let index = 1
  const itemsPath = [root]
  while (valuesPath.length > index) {
    const childToFind = valuesPath[index]
    index++

    const nextItem = children
      .flatMap(item => {
        if (typeValidator(SelectSection)(item)) {
          return Children.toArray(item.props.children)
        }
        return [item]
      })
      .find(
        (child): child is CascadeSelectItemPublicComponent =>
          typeValidator(CascadeSelectItem)(child) && child.props.value === childToFind
      )
    if (nextItem) {
      children = Children.toArray(nextItem?.props.children)
      itemsPath.push(selectItemPublicToDynamicItem(nextItem, 'cascade'))
      continue
    }
    const nextDynamicItem = getLazyLoadedCollection(valuesPath.slice(0, index - 1).join('.'))?.find(
      (item): item is DynamicCascadeItem =>
        item.itemType === 'cascade' && item.value === childToFind
    )
    if (nextDynamicItem) {
      itemsPath.push(nextDynamicItem)
      children = Children.toArray(nextDynamicItem.children)
      continue
    }
    break
  }

  return itemsPath
}
